import React from 'react';
import Container from '../atoms/Container';
import styled, { withTheme } from 'styled-components';

const Holder = styled.footer`
  display: grid;
  grid-template-columns: 1fr 1fr;
  font-family: noto-sans, sans-serif;
`;

const Column = styled.footer`
  &:first-child { 
    padding-right: 2rem; 
    @media(${props => props.theme.breakpoints.md}) {
      padding-right: 4rem; 
    }
    @media(${props => props.theme.breakpoints.lg}) {
      padding-right: 6rem; 
    }
  }
  &:last-child { 
    padding-left: 2rem;
    border-left: 1px solid; 
    @media(${props => props.theme.breakpoints.md}) {
      padding-left: 4rem; 
    }
    @media(${props => props.theme.breakpoints.mlg}) {
      padding-left: 6rem; 
    }
  }
  > :first-child { margin-top: 0; }
  > :last-child { margin-bottom: 0; }
  p, li { 
    ${props => props.theme.typeStyles(-2)}; 
    margin: 0.5rem 0;
    @media(${props => props.theme.breakpoints.md}) {
      ${props => props.theme.typeStyles( 0 )}; 
    }
    @media(${props => props.theme.breakpoints.lg}) {
      ${props => props.theme.typeStyles( 1 )}; 
    }
    @media(${props => props.theme.breakpoints.xl}) {
      ${props => props.theme.typeStyles( 2 )}; 
    }
  }
  ul {
    list-style: none;
    margin: 0;
    padding-left: 0;
  }
  a { 
    text-decoration: none; 
    &:hover { text-decoration: underline;  }
  }
`;

function Footer( { theme } ) {
  return (
    <Container bg={theme.colours.grey}>
      <Holder>
        <Column>
          <p><b>This explainer is funded by Facebook.</b></p>
          <p>If you're interested to know more, we've collated a set of resources to continue
            learning.</p>
        </Column>
        <Column>
          <p>Learn more about</p>
          <ul>
            <li><b>The Ad Ecosystem: </b>
              <a href="https://www.iab.com/insights/the-socioeconomic-impact-of-internet-tracking/" target="_blank" rel="noopener noreferrer">IAB
                Report (The Socioeconomic Impact of Internet Tracking)</a></li>
            <li><b>Data Education: </b>
              <a href="https://www.ttclabs.net/lens/educating-people-about-data" target="_blank" rel="noopener noreferrer">TTC Labs: Educating People About Data</a></li>
            <li><b>Direct to Consumer Brands: </b>
              <a href="https://www.iab.com/wp-content/uploads/2019/02/IAB_Direct-Brand-Economy-2019-Report-Short-Form-2019_2_11_FINAL-2.pdf" target="_blank" rel="noopener noreferrer">IAB
                Report (How To Build a 21st Century Brand)</a></li>
            <li><b>Audience Targeting & Data Privacy: </b>
              <a href="https://policies.google.com/technologies/cookies?hl=en-US" target="_blank" rel="noopener noreferrer">Google
                - How Do Cookies Work</a></li>
          </ul>
        </Column>
      </Holder>
    </Container>
  )
}

export default withTheme( Footer );
